import React, { useState, useEffect } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import NotificationIcon from "../../../src/assets/images/notification.svg";
import { notification } from "./api";
import { getToken } from "../../utils/utils";
import { formatDistanceToNowStrict } from "date-fns";
import { CircularProgress } from "@mui/material";                                                                                                                                                                                                   

// Define the structure of a notification item
interface NotificationItem {
  id: string; // Adjust to match your API's ID type
  message_en: string;
  createdAt: string;
}
const formatTime = (date: string) => {
  const timeDifference = formatDistanceToNowStrict(new Date(date), {
    addSuffix: false,
  });

  if (timeDifference.includes("minute")) {
    return timeDifference.replace("minutes", "m").replace("minute", "m");
  } else if (timeDifference.includes("hour")) {
    return timeDifference.replace("hours", "hr").replace("hour", "hr");
  } else if (timeDifference.includes("day")) {
    return timeDifference.replace("days", "d").replace("day", "d");
  }
  return timeDifference;
};
const Notifications: React.FC = () => {
  const token = getToken();
  const [notificationData, setNotificationData] = useState<
    NotificationItem[] | null
  >(null); // Explicitly type the state
  const [loading, setLoading] = useState(false); // Loading state
  useEffect(() => {
    fetchNotificationApi();
  }, []);

  const fetchNotificationApi = async () => {
    try {
      const reqBody = {
        status: "all",
      };
      setLoading(true);
      const res = await notification(reqBody, token);
      setNotificationData(res.data.data);
      console.log(res.data.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotificationData([]); // Fallback to an empty array on error
    }
    setLoading(false);
  };
  console.log("Notification Loader", loading);
  return (
    <Box
      sx={{
        width: "375px",
        backgroundColor: "#fff",
        boxShadow: 3,
        borderRadius: 2,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          mb: 0,
          paddingBottom: "10px",
          borderBottom: "1px solid #b5b5b5",
          p: 2,
        }}
      >
        Notifications
      </Typography>
      <Box sx={{ padding: "10px 0" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "200px", // Adjust height as needed
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <List sx={{ padding: "10px 10px" }}>
            {notificationData && notificationData.length > 0 ? (
              notificationData.map((notification) => (
                <ListItem
                  key={notification.id}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    padding: "15px 0",
                    borderBottom: "1px solid #b5b5b5",
                  }}
                >
                  <ListItemIcon>
                    <Box
                      sx={{
                        background: "#FFEBEF80",
                        borderRadius: "50px",
                        height: "40px",
                        width: "40px",
                      }}
                    >
                      {/* <img
                      style={{
                        position: "relative",
                        top: "6px",
                        left: "8px",
                      }}
                      src={NotificationIcon}
                      alt="notification"
                      width={30}
                      height={30}
                    /> */}
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                          position: "relative",
                          top: "6px",
                          left: "8px",
                        }}
                      >
                        <path
                          d="M12.02 2.91003C8.71003 2.91003 6.02003 5.60003 6.02003 8.91003V11.8C6.02003 12.41 5.76003 13.34 5.45003 13.86L4.30003 15.77C3.59003 16.95 4.08003 18.26 5.38003 18.7C9.69003 20.14 14.34 20.14 18.65 18.7C19.86 18.3 20.39 16.87 19.73 15.77L18.58 13.86C18.28 13.34 18.02 12.41 18.02 11.8V8.91003C18.02 5.61003 15.32 2.91003 12.02 2.91003Z"
                          stroke="#B90022"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                        />
                        <path
                          d="M13.87 3.19994C13.56 3.10994 13.24 3.03994 12.91 2.99994C11.95 2.87994 11.03 2.94994 10.17 3.19994C10.46 2.45994 11.18 1.93994 12.02 1.93994C12.86 1.93994 13.58 2.45994 13.87 3.19994Z"
                          stroke="#B90022"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601"
                          stroke="#B90022"
                          stroke-width="1.5"
                          stroke-miterlimit="10"
                        />
                      </svg>
                    </Box>
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "14px",
                      color: "#494A4B",
                    }}
                    primary={
                      <Typography variant="caption" sx={{ width: "90%" }}>
                        {notification.message_en}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="caption" color="textSecondary">
                        {notification.createdAt
                          ? formatTime(notification.createdAt)
                          : "No timestamp available"}
                      </Typography>
                    }
                    primaryTypographyProps={{ fontSize: "0.9rem" }}
                  />
                </ListItem>
              ))
            ) : (
              <Typography variant="body2" sx={{ textAlign: "center", p: 2 }}>
                No notifications available.
              </Typography>
            )}
          </List>
        )}
      </Box>
    </Box>
  );
};

export default Notifications;
